/**
 * PyreVault - Dark Fantasy Interactive Engine & Conversion Scripts
 */

(function () {
  'use strict';

  // 1. Countdown Timers
  function initCountdownTimers() {
    const timers = document.querySelectorAll('.js-pyre-timer');
    if (!timers.length) return;

    timers.forEach((timer) => {
      const endDateAttr = timer.getAttribute('data-end-date');
      const defaultHours = parseInt(timer.getAttribute('data-default-hours') || '24', 10);

      let targetTime;
      if (endDateAttr && !isNaN(Date.parse(endDateAttr))) {
        targetTime = new Date(endDateAttr).getTime();
      } else {
        // Dynamic cycling timer based on current day
        const now = new Date();
        const cycle = defaultHours * 60 * 60 * 1000;
        const remainder = cycle - (now.getTime() % cycle);
        targetTime = now.getTime() + remainder;
      }

      function updateClock() {
        const now = new Date().getTime();
        const distance = targetTime - now;

        if (distance < 0) {
          // Reset cycle
          targetTime = new Date().getTime() + (defaultHours * 60 * 60 * 1000);
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const daysEl = timer.querySelector('.js-timer-days');
        const hoursEl = timer.querySelector('.js-timer-hours');
        const minsEl = timer.querySelector('.js-timer-minutes');
        const secsEl = timer.querySelector('.js-timer-seconds');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(minutes).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(seconds).padStart(2, '0');
      }

      updateClock();
      setInterval(updateClock, 1000);
    });

    // Hero Ticker Countdown
    const tickers = document.querySelectorAll('.js-pyre-countdown');
    tickers.forEach((ticker) => {
      const hours = parseInt(ticker.getAttribute('data-hours') || '12', 10);
      function updateTicker() {
        const now = new Date();
        const totalSecs = (hours * 3600) - ((Math.floor(now.getTime() / 1000)) % (hours * 3600));
        const h = Math.floor(totalSecs / 3600);
        const m = Math.floor((totalSecs % 3600) / 60);
        const s = totalSecs % 60;
        ticker.textContent = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      }
      updateTicker();
      setInterval(updateTicker, 1000);
    });
  }

  // 2. 1-Click Coupon Code Copier
  function initCouponCopier() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.js-copy-coupon');
      if (!btn) return;

      const code = btn.getAttribute('data-code');
      if (!code) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          showCopied(btn);
        }).catch(() => {
          fallbackCopy(code, btn);
        });
      } else {
        fallbackCopy(code, btn);
      }
    });

    function showCopied(btn) {
      const textEl = btn.querySelector('.js-copy-text');
      const originalText = textEl ? textEl.textContent : 'COPY';
      if (textEl) textEl.textContent = 'COPIED!';
      btn.classList.add('is-copied');

      setTimeout(() => {
        if (textEl) textEl.textContent = originalText;
        btn.classList.remove('is-copied');
      }, 2500);
    }

    function fallbackCopy(text, btn) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        showCopied(btn);
      } catch (err) {
        console.error('Fallback copy failed', err);
      }
      document.body.removeChild(textArea);
    }
  }

  // 3. Dynamic Cart Goal Progress Listener
  function initCartGoalListener() {
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        updateCartGoal(event.cart);
      });
    }

    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) {
        updateCartGoal(e.detail.cart);
      }
    });

    function updateCartGoal(cart) {
      const goalEl = document.querySelector('.pyre-cart-goal');
      if (!goalEl || !cart) return;

      const threshold = parseInt(goalEl.getAttribute('data-threshold') || '7500', 10);
      const total = cart.total_price;
      const fillEl = goalEl.querySelector('.pyre-cart-goal__fill');
      const msgEl = goalEl.querySelector('.pyre-cart-goal__message');

      if (total >= threshold) {
        if (fillEl) {
          fillEl.style.width = '100%';
          fillEl.classList.add('is-unlocked');
        }
        if (msgEl) {
          msgEl.innerHTML = '<strong>Arcane Dispatch Unlocked!</strong> You qualify for <em>Free Shipping</em>.';
        }
      } else {
        const percent = Math.min(100, Math.round((total / threshold) * 100));
        const remaining = (threshold - total) / 100;
        if (fillEl) {
          fillEl.style.width = `${percent}%`;
          fillEl.classList.remove('is-unlocked');
        }
        if (msgEl) {
          msgEl.innerHTML = `Add <strong>$${remaining.toFixed(2)}</strong> more to claim <em>Free Arcane Dispatch</em>`;
        }
      }
    }
  }

  // 4. Ambient Ember Particles Effect
  function initEmberParticles() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const heroAmbient = document.querySelector('.pyre-hero__ambient-embers');
    if (!heroAmbient) return;

    const canvas = document.createElement('canvas');
    canvas.style.position = 'absolute';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '2';
    heroAmbient.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    let width, height;
    let particles = [];

    function resize() {
      width = canvas.width = heroAmbient.clientWidth || window.innerWidth;
      height = canvas.height = heroAmbient.clientHeight || 500;
    }

    resize();
    window.addEventListener('resize', resize);

    const PARTICLE_COUNT = 38;
    for (let i = 0; i < PARTICLE_COUNT; i++) {
      particles.push(createParticle(true));
    }

    function createParticle(randomY) {
      return {
        x: Math.random() * width,
        y: randomY ? Math.random() * height : height + 10,
        radius: Math.random() * 2.2 + 0.8,
        speedY: Math.random() * 0.9 + 0.35,
        speedX: (Math.random() - 0.5) * 0.6,
        opacity: Math.random() * 0.7 + 0.3,
        fadeSpeed: Math.random() * 0.006 + 0.002,
        color: Math.random() > 0.35 ? '#f59e0b' : '#ff4d00'
      };
    }

    function animate() {
      ctx.clearRect(0, 0, width, height);

      for (let i = 0; i < particles.length; i++) {
        const p = particles[i];
        p.y -= p.speedY;
        p.x += p.speedX;
        p.opacity -= p.fadeSpeed;

        if (p.y < 0 || p.opacity <= 0) {
          particles[i] = createParticle(false);
          continue;
        }

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.globalAlpha = Math.max(0, p.opacity);
        ctx.shadowBlur = 10;
        ctx.shadowColor = p.color;
        ctx.fill();
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }

  // Initialize on DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCountdownTimers();
      initCouponCopier();
      initCartGoalListener();
      initEmberParticles();
    });
  } else {
    initCountdownTimers();
    initCouponCopier();
    initCartGoalListener();
    initEmberParticles();
  }
})();
